import {
  CONTEXT_DOCUMENTS_ORGANIZATION_IDS,
  CONTEXT_DOCUMENTS_ORGANIZATIONS,
} from '@/lib/constants/contextDocumentsOrganizations'
import type { IOrganization } from '@/types/organization'

const isContextDocumentsEnabled = (organization: IOrganization): boolean => {
  return (
    CONTEXT_DOCUMENTS_ORGANIZATIONS.includes(organization.name) ||
    CONTEXT_DOCUMENTS_ORGANIZATION_IDS.includes(organization.id)
  )
}

export default isContextDocumentsEnabled
